module.exports = __webpack_public_path__ + "img/left-arrow-white.7161975b.svg";